// function that stop users to write e, +, -, and decimal point in number field.

// e => 69
// + => 107, 187
// - => 109, 189
// . => 110, 190
const invalidKeysForInt = [69, 107, 109, 110, 187, 189, 190];
const invalidKeysForFloat = [69, 107, 109, 187, 189];

export const onlyNumberKeys = (e, isFloat = false) => {
  const invalidKeys = isFloat ? invalidKeysForFloat : invalidKeysForInt;

  if (invalidKeys.includes(e.nativeEvent.which)) {
    e.preventDefault();
  }
};
